import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setGetInformationUsers} from '../store/thunk/setGetInformationUsers';
import TwoRow from '../components/twoRow';
import {useStyles} from './helpers'
import Title from '../../../../@casino/ui/title';
import {useFormik, FormikContext} from "formik";
import Switch from '@material-ui/core/Switch';
import {getDateFormManually, getDateForm} from '../../../../@casino/lib/getDate';
import CountOnline from '../components/online';
import { setGetCountOnline } from '../store/thunk/setGetCountOnline';
import ListUsers from '../components/list';

const InformationPanel = () => {
    const dispatch = useDispatch();
    const classes = useStyles();

    React.useEffect(() => {
        dispatch(setGetInformationUsers({
            date_from: 0,
            date_to: new Date().getTime()
        }));
        dispatch(setGetCountOnline())
    }, []);

    const initialValues = {
        check: false,
        search: '',
        date_from: NaN,
        date_to: NaN
    }

    const formik = useFormik({initialValues});
    
    const getDate = (val, check, from) => {
        const date = new Date(val);
        if (!check) {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
        }
        if (from) {
            return isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime();
        } else {
            return isNaN(date.getTime()) ? new Date().getTime() : date.getTime();
        }   
    }
    const users = useSelector(state => state.information.count_online);

    return ( 
        <div className={classes.root}>
            <Title label="Информационная панель" />
            <FormikContext.Provider value={formik}>
                <form>
                    <div style={{
                        padding: 20, 
                        background: '#1b2039', 
                        borderRadius: 8, 
                        marginBottom: 12,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <div style={{display: 'flex', marginRight: 12}}>
                            <label htmlFor="check" className={classes.wrapSwitch}>
                                <span className={classes.manually}>Ручн. время</span>
                                <Switch
                                    checked={formik.values.check}
                                    onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                    color="primary"
                                    name="checkedB"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </label>
                            <span className={classes.spo}>С</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                className={classes.datetime}
                                value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(0);
                                        date.setMinutes(0);
                                        date.setSeconds(0);
                                        date.setMilliseconds(0);
                                    }

                                    formik.setFieldValue('date_from', date.getTime());

                                    dispatch(setGetInformationUsers({
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime(),
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                    }))
                                }}
                            />
                            <span className={classes.spo}>ПО</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                style={{border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff'}} 
                                value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(23);
                                        date.setMinutes(59);
                                        date.setSeconds(59);
                                        date.setMilliseconds(999);
                                    }

                                    formik.setFieldValue('date_to', date.getTime());

                                    dispatch(setGetInformationUsers({
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : formik.values.date_from,
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : date.getTime(),
                                    }))
                                    
                                }}
                            />
                        </div>
                        <CountOnline users={users} />
                    </div>
                </form>
            </FormikContext.Provider>
            <div className={classes.wrap} style={{display: 'flex', justifyContent: 'space-between', gap: 25, flexDirection: 'row', width: 'calc(100% - 10px)'}}>
                <ListUsers users={users?.items || []}/>
                <TwoRow date_from={getDate(formik.values.date_from, formik.values.check, true)} date_to={getDate(formik.values.date_to, formik.values.check)} />
            </div>
        </div>
    )
}

export default InformationPanel;